export default "__VITE_ASSET__B5a_lxwE__";